module.exports = __webpack_public_path__ + "img/reservation.f007cd38.png";